import React from "react"
import { Box } from "@mallardbay/lib-react-components"

import type { NavigationMenuGroupFieldsFragment } from "~graphql/dashboard.generated"
import SidebarItem from "~components/shared/sidebar/sidebar-item"
import SidebarItemGroupHeader from "~components/shared/sidebar/sidebar-item-group-header"

type SidebarItemGroupProps = {
    readonly menuGroup: NavigationMenuGroupFieldsFragment
    readonly isCollapsed: boolean
    readonly onToggleGroup: (groupName: string) => void
    readonly isSidebarCollapsed: boolean
}

export default function SidebarItemGroup({
    menuGroup,
    isCollapsed,
    onToggleGroup,
    isSidebarCollapsed,
}: SidebarItemGroupProps): React.ReactElement {
    return (
        <Box>
            <SidebarItemGroupHeader
                label={menuGroup.label}
                isCollapsed={isCollapsed}
                onToggle={() => onToggleGroup(menuGroup.label ?? "")}
            />
            {!isCollapsed && (
                <Box>
                    {menuGroup.items.map((item) => (
                        <SidebarItem
                            key={item.label}
                            menuItem={item}
                            isSidebarCollapsed={isSidebarCollapsed}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}
